import React, { useEffect, useState } from "react";
import CollapseLabel from "../components/CollapseLabel";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  FetchStudBookBreederOwnerDetailsthunk,
  FetchStudBookHorseCompetitionthunk,
  FetchStudBookHorseDetailsthunk,
  FetchStudBookHorsePedigreeByIdthunk,
  FetchStudBookHorseProgenythunk,
  FetchStudBookLanguagethunk,
  FetchStudBookOwnerDetailsthunk,
  FetchStudBookSiblingsDamthunk,
  FetchStudBookSiblingsSireAndDamthunk,
  FetchStudBookSiblingsSirethunk,
} from "../Redux/StudBook/StudBookAction";
import {
  incrementPageHorseCompetition,
  incrementPageProgeny,
  incrementPageSiblingsDam,
  incrementPageSiblingsSire,
  incrementPageSiblingsSireAndDam,
} from "../Redux/StudBook/StudBookSlice";
import HorseDetailsPedigreeChart from "../components/HorseDetailsPedigreeChart";

import { useTranslate } from "../components/TranslationText";

import Loader from "../components/Loader";
import HorseCard from "../components/HorseCard";
import StudBookTab from "../components/StudBookTab";
import axiosInstance from "../axios/axios";
import { formatDate } from "../helper/formatDate";
import CompetitionsTab from "../components/CompetitionsTab";
import StudBookCard from "../components/StudBookCard";
import RaceChampionCard from "../components/RaceChampionCard";
import { getHorseEraRaceingResults } from "./sharedAPI/lookUpApis";
import { formatDateTimeToString } from "../helper/formatDateTimeToString";

export default function HorseDetailsPage() {
  // get hourse data from backend
  const location = useLocation();
  const { translate } = useTranslate();
  const navigate = useNavigate();
  const isTestApp = process.env.REACT_APP_IS_TEST;


  const searchParams = new URLSearchParams(location.search);
  const currentHorseId = searchParams.has("horseId")
    ? searchParams.get("horseId")
    : null;

  const {
    studBookLoading,
    studBookData,
    studBookProgenyData,
    studBookSiblingsSireAndDamData,
    studBookSiblingsSireData,
    studBookSiblingsDamData,
    studBookHorseCompetitionData,
    studBookPedigreeData,
    studBookHorseDetailsData,
    ownerDetailsData,
    breederOwnerDetailsData,
    takeProgeny,
    pageProgeny,
    totalCountProgeny,

    takeSiblingsSireAndDam,
    pageSiblingsSireAndDam,
    totalCountSiblingsSireAndDam,

    takeSiblingsSire,
    pageSiblingsSire,
    totalCountSiblingsSire,

    takeSiblingsDam,
    pageSiblingsDam,
    totalCountSiblingsDam,

    takeHorseCompetition,
    pageHorseCompetition,
    totalCountHorseCompetition,
    currentLanguage,
  } = useSelector((state) => state.studBookSlice);

  const dispatch = useDispatch();

  // console.log(studBookHorseDetailsData);
  // console.log(studBookPedigreeData);
  //const pedigreeArray = Object.entries(studBookPedigreeData);

  const TabStyle = {
    display: "block",
    padding: "10px 20px",
    textAlign: "center",
    background: "rgba(0,0,0,0.08)",
    cursor: "pointer",
    color: "#000",
    transition: "all 300ms",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  };

  const paginiateStyle = {
    width: 36,
    height: 36,
    background: "#E44D52",
    display: "inline-block",
    lineHeight: "37px",
    color: "#fff",
    cursor: "pointer",
    margin: 5,
    borderRadius: 8,
  };
  const pagenumberStyle = {
    ...paginiateStyle,
    width: 36,
    height: 36,
    background: "#ffffff",
    display: "inline-block",
    lineHeight: "37px",
    color: "black",
    cursor: "pointer",
    margin: 5,
    borderRadius: 8,
    borderColor: "#c0cedd",
    borderStyle: "solid",
  };

  const handlePageChange = (page) => {
    dispatch(incrementPageProgeny(page));
  };

  const handlePageChangeSiblingsSireAndDam = (page) => {
    dispatch(incrementPageSiblingsSireAndDam(page));
  };
  const handlePageChangeSiblingsSire = (page) => {
    dispatch(incrementPageSiblingsSire(page));
  };
  const handlePageChangeSiblingsDam = (page) => {
    dispatch(incrementPageSiblingsDam(page));
  };
  const handlePageChangeHorseCompetition = (page) => {
    dispatch(incrementPageHorseCompetition(page));
  };

  // Function to render pagination buttons
  const renderPagination = () => {
    const pages = [];

    const numPages = Math.ceil(totalCountProgeny / takeProgeny);

    for (let i = 1; i <= numPages; i++) {
      pages.push(
        <React.Fragment>
          <span
            key={i}
            className={`btn btn-dark ${i === pageProgeny ? 'disabled' : ''}`}


            onClick={() => handlePageChange(i)}
          >
            {i}
          </span>
        </React.Fragment>
      );
    }

    let _pages = [];

    if (pages.length >= 5 && pageProgeny === 1) {
      _pages = pages
        .slice(pageProgeny - 1, 3)
        .concat(<span>...</span>)
        .concat(pages.slice(-1));
    }

    if (pageProgeny > 1) {
      _pages = pages.slice(pageProgeny);
    }
    if (pageProgeny > 1 && numPages - pageProgeny > 3) {
      _pages = pages
        .slice(pageProgeny - 1, pageProgeny)
        .concat(_pages.slice(0, 2))
        .concat(<span>...</span>)
        .concat(pages.slice(-1));
    }

    if (pageProgeny === 1 && numPages - pageProgeny <= 3) {
      _pages = pages;
      if (studBookProgenyData.length === 0) {
        _pages = [];
      }
    }

    if (pageProgeny > 1 && numPages - pageProgeny <= 3) {
      _pages = pages
        .slice(pageProgeny - 1, pageProgeny)
        .concat(_pages.slice(0, 3));
    }

    return _pages;
  };

  const renderPaginationSiblingsSireAndDam = () => {
    const pages = [];

    const numPages = Math.ceil(
      totalCountSiblingsSireAndDam / takeSiblingsSireAndDam
    );

    for (let i = 1; i <= numPages; i++) {
      pages.push(
        <React.Fragment>
          <span
            key={i}
            className={`btn btn-dark ${i === pageSiblingsSireAndDam ? 'disabled' : ''}`}


            onClick={() => handlePageChangeSiblingsSireAndDam(i)}
          >
            {i}
          </span>
        </React.Fragment>
      );
    }

    let _pages = [];

    if (pages.length >= 5 && pageSiblingsSireAndDam === 1) {
      _pages = pages
        .slice(pageSiblingsSireAndDam - 1, 3)
        .concat(<span>...</span>)
        .concat(pages.slice(-1));
    }

    if (pageSiblingsSireAndDam > 1) {
      _pages = pages.slice(pageSiblingsSireAndDam);
    }
    if (pageSiblingsSireAndDam > 1 && numPages - pageSiblingsSireAndDam > 3) {
      _pages = pages
        .slice(pageSiblingsSireAndDam - 1, pageSiblingsSireAndDam)
        .concat(_pages.slice(0, 2))
        .concat(<span>...</span>)
        .concat(pages.slice(-1));
    }

    if (
      pageSiblingsSireAndDam === 1 &&
      numPages - pageSiblingsSireAndDam <= 3
    ) {
      _pages = pages;
      if (studBookSiblingsSireAndDamData.length === 0) {
        _pages = [];
      }
    }

    if (pageSiblingsSireAndDam > 1 && numPages - pageSiblingsSireAndDam <= 3) {
      _pages = pages
        .slice(pageSiblingsSireAndDam - 1, pageSiblingsSireAndDam)
        .concat(_pages.slice(0, 3));
    }

    return _pages;
  };

  const renderPaginationSiblingsSire = () => {
    const pages = [];

    const numPages = Math.ceil(totalCountSiblingsSire / takeSiblingsSire);

    for (let i = 1; i <= numPages; i++) {
      pages.push(
        <span
          key={i}
          className={`btn btn-dark ${i === pageSiblingsSire ? 'disabled' : ''}`}


          onClick={() => handlePageChangeSiblingsSire(i)}
        >
          {i}
        </span>
      );
    }

    let _pages = [];

    if (pages.length >= 5 && pageSiblingsSire === 1) {
      _pages = pages
        .slice(pageSiblingsSire - 1, 3)
        .concat(<span>...</span>)
        .concat(pages.slice(-1));
    }

    if (pageSiblingsSire > 1) {
      _pages = pages.slice(pageSiblingsSire);
    }
    if (pageSiblingsSire > 1 && numPages - pageSiblingsSire > 3) {
      _pages = pages
        .slice(pageSiblingsSire - 1, pageSiblingsSire)
        .concat(_pages.slice(0, 2))
        .concat(<span>...</span>)
        .concat(pages.slice(-1));
    }

    if (pageSiblingsSire === 1 && numPages - pageSiblingsSire <= 3) {
      _pages = pages;
      if (studBookSiblingsSireData.length === 0) {
        _pages = [];
      }
    }

    if (pageSiblingsSire > 1 && numPages - pageSiblingsSire <= 3) {
      _pages = pages
        .slice(pageSiblingsSire - 1, pageSiblingsSire)
        .concat(_pages.slice(0, 3));
    }

    return _pages;
  };

  const renderPaginationSiblingsDam = () => {
    const pages = [];

    const numPages = Math.ceil(totalCountSiblingsDam / takeSiblingsDam);

    for (let i = 1; i <= numPages; i++) {
      pages.push(
        <React.Fragment>
          <span
            onClick={() => handlePageChangeSiblingsDam(i)}
            key={i}
            className={`btn btn-dark ${i === pageSiblingsDam ? 'disabled' : ''}`}
          >
            {i}
          </span>
        </React.Fragment>
      );
    }

    let _pages = [];

    if (pages.length >= 5 && pageSiblingsDam === 1) {
      _pages = pages
        .slice(pageSiblingsDam - 1, 3)
        .concat(<span>...</span>)
        .concat(pages.slice(-1));
    }

    if (pageSiblingsDam > 1) {
      _pages = pages.slice(pageSiblingsDam);
    }
    if (pageSiblingsDam > 1 && numPages - pageSiblingsDam > 3) {
      _pages = pages
        .slice(pageSiblingsDam - 1, pageSiblingsDam)
        .concat(_pages.slice(0, 2))
        .concat(<span>...</span>)
        .concat(pages.slice(-1));
    }

    if (pageSiblingsDam === 1 && numPages - pageSiblingsDam <= 3) {
      _pages = pages;
      if (studBookSiblingsDamData.length === 0) {
        _pages = [];
      }
    }

    if (pageSiblingsDam > 1 && numPages - pageSiblingsDam <= 3) {
      _pages = pages
        .slice(pageSiblingsDam - 1, pageSiblingsDam)
        .concat(_pages.slice(0, 3));
    }

    return _pages;
  };

  const renderPaginationHorseCompetition = () => {
    const pages = [];

    const numPages = Math.ceil(
      totalCountHorseCompetition / takeHorseCompetition
    );

    for (let i = 1; i <= numPages; i++) {
      pages.push(
        <React.Fragment>
          <span
            key={i}
            className={`btn btn-dark ${i === pageHorseCompetition ? 'disabled' : ''}`}
            onClick={() => handlePageChangeHorseCompetition(i)}
          >
            {i}
          </span>
        </React.Fragment>
      );
    }

    let _pages = [];

    if (pages.length >= 5 && pageHorseCompetition === 1) {
      _pages = pages
        .slice(pageHorseCompetition - 1, 3)
        .concat(<span>...</span>)
        .concat(pages.slice(-1));
    }

    if (pageHorseCompetition > 1) {
      _pages = pages.slice(pageHorseCompetition);
    }
    if (pageHorseCompetition > 1 && numPages - pageHorseCompetition > 3) {
      _pages = pages
        .slice(pageHorseCompetition - 1, pageHorseCompetition)
        .concat(_pages.slice(0, 2))
        .concat(<span>...</span>)
        .concat(pages.slice(-1));
    }

    if (pageHorseCompetition === 1 && numPages - pageHorseCompetition <= 3) {
      _pages = pages;
      if (studBookHorseCompetitionData.length === 0) {
        _pages = [];
      }
    }

    if (pageHorseCompetition > 1 && numPages - pageHorseCompetition <= 3) {
      _pages = pages
        .slice(pageHorseCompetition - 1, pageHorseCompetition)
        .concat(_pages.slice(0, 3));
    }

    return _pages;
  };

  const [siblingsOfsireDamActive, setSiblingsOfsireDamActive] = useState(true);
  const [siblingsDamActive, setSiblingsDamActive] = useState(false);
  const [siblingsSireActive, setSiblingsSireActive] = useState(false);
  const [selectedSearchType, setSelectedSearchType] = useState(1);
  const aboutArray = Object.entries(studBookHorseDetailsData);
  const handleSelectedSearchType = (e) => {
    setSelectedSearchType(e);
  };

  useEffect(() => {
    let params = {
      id: currentHorseId,
      langauge: currentLanguage,
    };

    dispatch(FetchStudBookHorseDetailsthunk(params));
  }, [currentLanguage, currentHorseId, dispatch]);

  useEffect(() => {
    let paramsProgeny = {
      id: currentHorseId,
      skip: (pageProgeny - 1) * takeProgeny,
      take: takeProgeny,
      langauge: currentLanguage,
    };
    dispatch(FetchStudBookHorseProgenythunk(paramsProgeny));
  }, [pageProgeny, currentLanguage, currentHorseId]);

  useEffect(() => {
    if (selectedSearchType === 1) {
      let paramsSiblingsSireAndDam = {
        id: currentHorseId,
        skip: (pageSiblingsSireAndDam - 1) * takeSiblingsSireAndDam,
        take: takeSiblingsSireAndDam,
        langauge: currentLanguage,
      };
      dispatch(FetchStudBookSiblingsSireAndDamthunk(paramsSiblingsSireAndDam));
    } else if (selectedSearchType === 2) {
      let paramsSiblingsSire = {
        id: currentHorseId,
        skip: (pageSiblingsSire - 1) * takeSiblingsSire,
        take: takeSiblingsSire,
        langauge: currentLanguage,
      };
      dispatch(FetchStudBookSiblingsSirethunk(paramsSiblingsSire));
    } else if (selectedSearchType === 3) {
      let paramsSiblingsDam = {
        id: currentHorseId,
        skip: (pageSiblingsDam - 1) * takeSiblingsDam,
        take: takeSiblingsDam,
        langauge: currentLanguage,
      };
      dispatch(FetchStudBookSiblingsDamthunk(paramsSiblingsDam));
    }
  }, [
    pageSiblingsSireAndDam,
    pageSiblingsSire,
    pageSiblingsDam,
    selectedSearchType,
    currentLanguage,
    currentHorseId,
  ]);

  useEffect(() => {
    let paramsHorseCompetition = {
      id: currentHorseId,
      skip: (pageHorseCompetition - 1) * takeHorseCompetition,
      take: takeHorseCompetition,
      langauge: currentLanguage,
    };
    dispatch(FetchStudBookHorseCompetitionthunk(paramsHorseCompetition));
  }, [pageHorseCompetition, currentLanguage, currentHorseId]);

  useEffect(() => {
    let paramsHorsePedigree = {
      id: currentHorseId,
      langauge: currentLanguage,
    };
    dispatch(FetchStudBookHorsePedigreeByIdthunk(paramsHorsePedigree));
  }, [currentLanguage, currentHorseId]);

  useEffect(() => {
    dispatch(FetchStudBookLanguagethunk(currentLanguage === "en" ? "1" : "2"));
  }, [currentLanguage]);

  useEffect(() => {
    if (Object.keys(studBookHorseDetailsData).length !== 0) {
      if (studBookHorseDetailsData.ownerIdGuid != null) {
        dispatch(
          FetchStudBookOwnerDetailsthunk({
            ownerId: studBookHorseDetailsData.ownerIdGuid,
            langauge: currentLanguage,
          })
        );
      }
      if (studBookHorseDetailsData.breederOwnerIdGuid != null) {
        dispatch(
          FetchStudBookBreederOwnerDetailsthunk({
            ownerId: studBookHorseDetailsData.breederOwnerIdGuid,
            langauge: currentLanguage,
          })
        );
      }
    }
  }, [currentLanguage, studBookHorseDetailsData]);

  // check if the hourse has WahoTrophy
  const [wahoTrophy, setWahoTrophy] = useState([]);
  async function getWahoList() {
    try {
      const response = await axiosInstance.get(`/wahotrophy/gethorsewahotrophies?id=${currentHorseId}&lang=${currentLanguage}`)
      if (response.data.responseCode == "200") {
        setWahoTrophy(response.data.result);
      } else {
        console.log('error in getting wahoList')
      }
    } catch (error) {
      console.log('error in getting wahoList')
    }
  }

  const [currentPage, setCurrentPage] = useState(0);
  const [raceingArray, setRaceingArray] = useState([]);

  useEffect(() => {
    getHorseEraRaceingResults(currentHorseId).then((res) => {
      setRaceingArray(res)
    })
    getWahoList();
  }, [currentHorseId, currentLanguage])

  const rowPerPage = 10;

  const startIndex = currentPage * rowPerPage;
  const endIndex = startIndex + rowPerPage;
  const displayerdRacingArray = raceingArray.slice(startIndex, endIndex);
  const totalPages = Math.ceil(raceingArray.length / rowPerPage);
  const isFirstPage = currentPage === 0;
  const isLastPage = currentPage >= totalPages - 1;
  return (
    <>
      <div className="row rtl">

        <h2 className="col-lg-12 col-md-12 col-sm-12 mb-main  bold rtl capatalise">
          {studBookLoading && <Loader />}
          {!!aboutArray &&
            aboutArray.length > 0 &&
            !!aboutArray[3] &&
            aboutArray[3][1]}
          {!!!studBookHorseDetailsData?.isAlive &&
            <span className="text-danger rtl" style={{ margin: "auto 10px" }}>
              ({translate('web.dead', 'Dead')}{!!studBookHorseDetailsData?.deathDate && ("  " + studBookHorseDetailsData?.deathDate)})
            </span>
          }
        </h2>
        {wahoTrophy.length > 0 &&
          <div className="col-md-12 col-sm-12 row mb-main  rtl ">
            {wahoTrophy.map((item, index) => (
              <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                <i class="fa fa-trophy C89C66" ></i> {item.year} {index + 1 < wahoTrophy.length ? " - " : ''}
              </div>
            ))}
          </div>
        }


        <CollapseLabel name={translate("web.aboutHorse", "About Horse")}>
          {
            <div className="bg-white mb-main p-main border-15 p-3  ">
              <div className="row">

                <StudBookCard title={translate("web.birthDate", "Birthdate")} text={formatDateTimeToString(studBookHorseDetailsData?.birthDateObject)} />
                <StudBookCard title={translate("web.regno", "Reg No")} text={'# ' + studBookHorseDetailsData?.registerNumber} />
                <StudBookCard title={translate("web.owner", "Owner")} text={studBookHorseDetailsData?.owner} isOwner={true} ownerDetailsData={ownerDetailsData} navigate={navigate} />
                <StudBookCard title={translate("web.breeder", "Breeder")} text={studBookHorseDetailsData?.breeder} />
                <StudBookCard title={translate("web.color", "color")} text={studBookHorseDetailsData?.color} />
                <StudBookCard title={translate("web.origin", "Origin")} text={studBookHorseDetailsData?.origin} />
                <StudBookCard title={translate("web.gender", "Gender")} text={translate('web.' + studBookHorseDetailsData?.gender, studBookHorseDetailsData?.gender)} />
                <StudBookCard title={translate("web.sire", "Sire")} text={studBookHorseDetailsData?.sire} isSire={true} sireId={studBookPedigreeData?.sireId} isEnabled={!!studBookPedigreeData?.sireRegistrationNumber} />
                <StudBookCard title={translate("web.dam", "Dam")} text={studBookHorseDetailsData?.dam} isDam={true} damId={studBookPedigreeData?.damId} isEnabled={!!studBookPedigreeData?.damRegistrationNumber} />
                <StudBookCard title={translate("web.horseUeln", "UELN")} text={studBookHorseDetailsData?.horseUeln} />
                {!!studBookHorseDetailsData?.raceNameEn &&
                  <StudBookCard title={translate("web.raceHorseName", "Race Name")} text={studBookHorseDetailsData?.raceNameEn} />
                }
                {studBookHorseDetailsData?.isExported &&
                  <>
                    <StudBookCard title={translate("web.exportCountry", "Export Country")} text={studBookHorseDetailsData?.exportCountry} />
                    <StudBookCard title={translate("web.exportDate", "Export Date")} text={formatDateTimeToString(studBookHorseDetailsData?.exportDateObject)} />
                  </>
                }
                {studBookHorseDetailsData?.isImported &&
                  <>
                    <StudBookCard title={translate("web.importCountry", "Import Country")} text={studBookHorseDetailsData?.importCountry} />
                    <StudBookCard title={translate("web.importDate", "Import Date")} text={formatDateTimeToString(studBookHorseDetailsData?.importDateObject)} />
                  </>
                }
              </div>
            </div>
          }

        </CollapseLabel>
        <CollapseLabel name={translate("web.pedigree", "Pedigree")}>
          {!!studBookPedigreeData && (
            <HorseDetailsPedigreeChart hierarchy={studBookPedigreeData} />
          )}
        </CollapseLabel>
        <CollapseLabel name={translate("web.progeny", "Progeny")}>
          <div className="row mb-main">
            <StudBookTab
              Data={studBookProgenyData}
              handlePageChange={handlePageChange}
              page={pageProgeny}
              renderPagination={renderPagination}
              take={takeProgeny}
              totalCount={totalCountProgeny}
              noBackGround={true}
            />
          </div>
        </CollapseLabel>
        <CollapseLabel name={translate("web.siblings", "Siblings")}>
          <div className="row second_section_bar mb-main">
            <div
              className={'col-4 my-2 text-center pe-0 '}
              style={{ cursor: 'pointer', minWidth: 250 }}
              id="second_most_used_services"
              onClick={() => {
                setSiblingsOfsireDamActive(true);
                setSiblingsSireActive(false);
                setSiblingsDamActive(false);
                handleSelectedSearchType(1);
              }}
            >
              <span className={`${siblingsOfsireDamActive ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 15 }}>{translate("web.siblingsOfSireDam", "Siblings Of Sire Dam")}</span>
              <div className="service_bar_underline" style={siblingsOfsireDamActive ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
            </div>
            <div
              className={'col-4 my-2 text-center px-0 '}
              id="second_most_used_services"
              style={{ cursor: 'pointer', minWidth: 250 }}
              onClick={() => {
                setSiblingsOfsireDamActive(false);
                setSiblingsSireActive(false);
                setSiblingsDamActive(true);
                handleSelectedSearchType(3);
              }}
            >
              <span className={`${siblingsDamActive ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 15 }}>{translate("web.siblingsDam", "Siblings Dam")}</span>
              <div className="service_bar_underline" style={siblingsDamActive ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
            </div>
            <div
              className={'col-4 my-2 text-center ps-0 '}
              id="second_most_used_services"
              style={{ cursor: 'pointer', minWidth: 250 }}
              onClick={() => {
                setSiblingsOfsireDamActive(false);
                setSiblingsSireActive(true);
                setSiblingsDamActive(false);
                handleSelectedSearchType(2);
              }}
            >
              <span className={`${siblingsSireActive ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 15 }}>{translate("web.siblingsSire", "Siblings Sire")}</span>

              <div className="service_bar_underline" style={siblingsSireActive ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 mb-main ">
              <div className="row ">
                {selectedSearchType === 1 && (
                  <StudBookTab
                    Data={studBookSiblingsSireAndDamData}
                    handlePageChange={handlePageChangeSiblingsSireAndDam}
                    page={pageSiblingsSireAndDam}
                    renderPagination={renderPaginationSiblingsSireAndDam}
                    take={takeSiblingsSireAndDam}
                    totalCount={totalCountSiblingsSireAndDam}
                  />
                )}


                {selectedSearchType === 2 && (
                  <StudBookTab Data={studBookSiblingsSireData} handlePageChange={handlePageChangeSiblingsSire} page={pageSiblingsSire} renderPagination={renderPaginationSiblingsSire} take={takeSiblingsSire} totalCount={totalCountSiblingsSire} />
                )}

                {selectedSearchType === 3 && (
                  <StudBookTab
                    Data={studBookSiblingsDamData}
                    handlePageChange={handlePageChangeSiblingsDam}
                    page={pageSiblingsDam}
                    renderPagination={renderPaginationSiblingsDam}
                    take={takeSiblingsDam}
                    totalCount={totalCountSiblingsDam}
                  />
                )}
              </div>
            </div>
          </div>
        </CollapseLabel>
        <div className="mb-main">
          <CollapseLabel name={translate("web.competitions", "Competitions")}>
            <CompetitionsTab
              studBookHorseCompetitionData={studBookHorseCompetitionData}
              translate={translate}
              className=""
              pageHorseCompetition={pageHorseCompetition}

              handlePageChangeHorseCompetition={handlePageChangeHorseCompetition}
              renderPaginationHorseCompetition={renderPaginationHorseCompetition}
              totalCountHorseCompetition={totalCountHorseCompetition}
              takeHorseCompetition={takeHorseCompetition}
            />
          </CollapseLabel>
        </div>
        {displayerdRacingArray?.length > 0 &&
          <CollapseLabel name={translate("web.flatRaces", "Flat Races")}>
            <div className="hourseCardClass bg-white p-main p-3  position-relative">
              <div className="scrolableTable mx-auto " >
                <div className="row mx-0">
                  <table className="table tablenominwidth table-striped table-bordered rtl horseResultTable">
                    <thead className="theadHorseSelect">
                      <tr>
                        {cell(translate("web.raceDate", 'Race Date'))}
                        {cell(translate("web.fp", 'FP'))}
                        {cell(translate("web.winnerNd", 'Winner/2ND'))}
                        {cell(translate("web.margin", 'Margin'))}
                        {cell(translate("web.winnersTime", `Winner's Time`))}
                        {cell(translate("web.raceCourse", `Race Course`))}
                        {cell(translate("web.raceType", `Race Type`))}
                        {cell(translate("web.tord", `T/D`))}
                        {cell(translate("web.distance", `Distance`))}
                        {cell(translate("web.jockey", `Jockey`))}
                        {cell(translate("web.trainer", `Trainer`))}
                        {cell(translate("web.dr", `DR`))}
                        {cell(translate("web.rating", `Rating`))}
                        {cell(translate("web.weight", `Weight`))}
                        {cell(translate("web.sp", `SP`))}
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      {displayerdRacingArray.map((x) => (
                        <RaceChampionCard champCard={x} />
                      ))}
                    </tbody>
                  </table>
                  <div className="col-12 text-center">
                    <button
                      disabled={isFirstPage}
                      className="btn btn-dark mx-2 fw-bold"
                      onClick={() => setCurrentPage(prev => prev - 1)}
                    >
                      {"<"}
                    </button>
                    <span
                      className="btn btn-dark mx-2 fw-bold"
                    >
                      {currentPage + 1}  / {totalPages}
                    </span>
                    <button
                      disabled={isLastPage}
                      className="btn btn-dark mx-2 fw-bold"
                      onClick={() => setCurrentPage(prev => prev + 1)}
                    >
                      {">"}
                    </button>

                  </div>
                </div>
              </div>
            </div>
          </CollapseLabel>
        }
      </div>

    </>
  );
}
function cell(title, value) {
  return <th className="text-center">
    {title}
  </th>;
}

